// extracted by mini-css-extract-plugin
module.exports = {"main":"Imprint_main__1Oh1X","fillDiv":"Imprint_fillDiv__2OP6d"};